import React from "react";
import DataTable from "../../../Components/DataTable/DataTable";
import {
	alertBox,
	getStatusColor,
	noAvatar,
	toMoney,
} from "../../../Components/Functions";
import TimeSummary from "../../../Components/TimeSummary";
import { loggedUser } from "../../../Constants/menus";
import { routers } from "../../../Constants/routers";
import Api from "../../../Server/Api";
import { PaymentButton } from "../../patient/PaymentButton";
import { timeToShorts } from "./Dashboard";

const api = new Api();

export const RenderItem = ({ item }) => {
	const [accepting, setAccepting] = React.useState();

	const profile =
		loggedUser?.id === item?.specialist
			? item?.patient_info
			: item?.specialist_info;

	const acceptOrDecline = (is_accept = false) => {
		const slots = (item?.time_slots).map((e, i) => { return `<h3>(${i+1}) ${timeToShorts(e)}</h3>` }).join("")
		const body = `,
			<strong class="text-${is_accept ? "success" : "danger"}">${
			is_accept
				? "Are you sure you want to accept this appointment request?"
				: "Are you sure you want to decline this appointment request?"
		}</strong>
			<br/>
			<br/>
			<div class="user-grid user-grid-v1 is-media is-grow">
			<div class="grid-item">
			<div class="h-avatar is-big">
				<img class="avatar" src="${profile?.image || noAvatar()}" alt="" >
			</div>
			<h3 class="dark-inverted" data-filter-match="">${profile?.name}</h3>
			<p data-filter-match="">@${profile?.username}</p>

			<div class="buttonsx text-left mt-5" style="text-align: left">
				<p>Date & Time</p>
				<h3>${item?.date_time}</h3>
				<p>Message</p>
				<h3>${item?.message||"- No message -"}</h3>
				<p>Time Slots</p>
				<h3>${slots}</h3>
			</div>
		</div>
					</div>
		`;
		alertBox({
			title: is_accept ? "Accept Appointment" : "Decline Appointment",
			message: body,
			btnCallback: "Yes, " + (is_accept ? "Accept" : "Decline"),
			callback: (e) => {
				setAccepting(true);
				api.put({ endpoint: `/appointments/${item?.id}/accept_decline/`, data: { status: is_accept ? "ACCEPTED": "DECLINED" } })
				.then((res) => {
					setAccepting(false)
					if(res?.status) window.location = ""
				})
			},
		});
	};

	return (
		<div className="flex-table-item" style={{}}>
			<div className="flex-table-cell is-media is-grow" data-th="">
				<div className="h-avatar is-medium">
					<img
						className="avatar is-squared"
						src={profile?.image || noAvatar()}
						alt=""
					/>
				</div>
				<div>
					<span className="item-name dark-inverted is-font-alt is-weight-600">
						{profile?.title} {profile?.name}
					</span>
					<span className="item-meta">
						<span>
							<a
								href={routers.pages.doctor(profile?.username)}
								target={"_blank"}
								className="action-link"
							>
								@{profile?.username}
							</a>
						</span>
					</span>
				</div>
			</div>
			<div className="flex-table-cell" data-th="Date">
				<span className="light-text">{item?.date_time}</span>
			</div>
			<div className="flex-table-cell" data-th="Date">
				<TimeSummary {...item} />
			</div>
			<div className="flex-table-cell" data-th="Amount">
				<span className="dark-inverted is-weight-600">
					{toMoney(item?.transaction?.amount)}
				</span>
			</div>
			<div className="flex-table-cell" data-th="Status">
				<span className={`tag is-${getStatusColor(item?.transaction?.status)}`}>
					{item?.transaction?.status}
				</span>
			</div>
			{loggedUser?.id === item?.specialist ? (
				<div className="flex-table-cell cell-end" data-th="Actions">
					{(accepting && (
						<button className="button h-button is-outlined is-pushed-mobile mr-2">
							Processing...
						</button>
					)) || (
						<>
							<button
								onClick={() => acceptOrDecline(true)}
								className="button h-button is-success is-outlined is-pushed-mobile mr-2"
							>
								Accept
							</button>
							<button
								onClick={() => acceptOrDecline(false)}
								className="button h-button is-danger is-outlined is-pushed-mobile"
							>
								Decline
							</button>
						</>
					)}
				</div>
			) : (
				<div className="flex-table-cell cell-end" data-th="Actions">
					{item?.status === "ACCEPTED" &&
					item?.transaction?.status === "PENDING" &&
					item?.transaction?.amount > 100 ? (
						item?.has_expired ? (
							<button
								className={`button h-button is-danger is-outlined is-pushed-mobile`}
							>
								APPOINTMENT EXPIRED
							</button>
						) : (
							<PaymentButton amount={item?.transaction?.amount} id={item?.id} />
						)
					) : (
						<button
							className={`button h-button is-${getStatusColor(
								item?.status,
							)} is-outlined is-pushed-mobile`}
						>
							{item?.status}
						</button>
					)}
				</div>
			)}
		</div>
	);
};

const AppointmentRequests = ({ title="Appointment Requests", is_patient }) => {
	// const [] = React.useState([]);

	const renderItem = (item) => {
		return <RenderItem item={item} />;
	};
	return (
		<div className="column is-12">
			{/*Header*/}
			<div className="table-header" style={{ marginTop: 0 }}>
				<h3 className="dark-inverted">{title}</h3>
			</div>
			<div className="flex-table nobg-table">
				{/*Table header*/}
				<div className="flex-table-header">
					<span className="is-grow">Specialist</span>
					<span>Date</span>
					<span>Time Slots</span>
					<span>Amount</span>
					<span>Payment</span>
					<span className="cell-end">Actions</span>
				</div>
				{/*Table item*/}

				<DataTable
					header={[]}
					options={{
						allowRemove: false,
						allowBulkSelect: false,
						disableToolBar: true,
						disablePagination: false,
						disableSearch: true,
						removeEndPoint: "",
						endpoint: {
							url: `/users/${loggedUser?.username}/appointments/`,
							params: {
								statuses: is_patient ? ["PENDING", "ACCEPTED"] : ["PENDING"],
							},
						},
						left: [],
						right: [],
					}}
					renderItem={renderItem}
				/>
			</div>
		</div>
	);
};

export default AppointmentRequests;
